export default ({ $auth }) => {
	$auth.onRedirect((to, from) => {
		// return to;
	});
};
